export const labelToKey = (label) => (label || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, c) => c.toUpperCase())
    .replace(/[^a-zA-Z0-9]/g, '');

export const contactOriginAsLabelChoices = (list) => (list || [])
    .reduce((acc, { label }) => ({ ...acc, [label]: label }), {});

export const OTHER_CONTACT_ORIGIN_KEY = 'other';
export const OTHER_CONTACT_ORIGIN_LABEL = 'Autre';
